import { render } from "./AddMoreTyres.vue?vue&type=template&id=b2477d68"
import script from "./AddMoreTyres.vue?vue&type=script&lang=js"
export * from "./AddMoreTyres.vue?vue&type=script&lang=js"

import exportComponent from "/Users/marc.bush/Sites/ensotyres/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__